<template>
    <div>
        <ValidationObserver ref="filterForm">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox :validate-error="errors[0]"
                                                 v-model="filter.semester_id"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="course_code" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('course')">
                            <course-auto-complete
                                v-model="filter.course_code" :resultType="'code'"
                                :validate-error="errors[0]"
                            ></course-auto-complete>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="section" :rules="sectionRules" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('section_1')">
                            <b-form-input type="number"
                                          min="1"
                                          v-check-min-max-value
                                          v-model="filter.section"
                                          :placeholder="$t('section_1')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="number" rules="" v-slot="{errors}">
                        <b-form-group :label="$t('student_numbers')">
                            <lined-textarea v-model="filter.student_numbers"
                                            :nowrap="false"
                                            :disabled="false"
                                            :styles="{ height: '5em', resize: 'both' }"
                                            :validateError="errors[0]">
                            </lined-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-button variant="primary" @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete"
import LecturerReportService from "@/services/LecturerReportService"
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import qs from 'qs'
import LinedTextarea from "@/components/elements/LinedTextarea.vue";

export default {
    components: {
        LinedTextarea,
        SemestersSelectbox,
        MultiSelectbox,
        CourseAutoComplete,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            filter: {},
        }
    },
    computed: {
        sectionRules() {
            return this.filter.student_numbers ? '' : 'required';
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.filterForm.validate()

            if (isValid) {
                const config = {
                    params: {
                        semester_id: this.filter.semester_id,
                        course_code: this.filter.course_code,
                        section: this.filter.section,
                        student_numbers: this.filter.student_numbers
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };
                LecturerReportService.getStudentBasedFullScheduleReport(config)
                    .then((response) => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                    })
                    .catch((error) => {
                        this.showErrors(error)
                    })
            }
        }
    }
}
</script>
